import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { telemetryConsumerWrapper } from '~src/commonInfra/telemetryEvents/contexts/TelemetryConsumerWrapper';
import { ContentClickedTelemetryContext } from '~src/commonInfra/telemetryEvents/contexts/TelemetryContexts';
import { ContentClickedEventHandler } from '~src/commonInfra/telemetryEvents/types/ContentTelemetryTypes';
import { mouseUpFactory } from '~src/commonInfra/telemetryEvents/util/EventHandlerFactories';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { CommonTableInfo } from '~src/spacesPlatform/models/CommonTableInfo';

export type TableThumbnailProps = Pick<React.AriaAttributes, 'aria-label'> & {
    readonly allowDragAndDrop: boolean;
    readonly content: CommonTableInfo;
    readonly contentUrl?: string;
    readonly hoveredOrSelected?: boolean;
}

export class TableThumbnail extends React.Component<TableThumbnailProps> {
    public render() {
        const tableContent = this.props.content;
        const containerClass = this.props.hoveredOrSelected ? CardViewStyles.CustomThumbnailHoverNoPointer : CardViewStyles.CustomThumbnail;
        const isDbServer: boolean = tableContent.dbType === 'DatabaseServer';
        const imgUrl = imgPath('table_card.svg');
        const thumbnailSecondTitle = isDbServer ? Messages.tableCardHostname() + tableContent.hostName : Messages.tableCardFilepath() + tableContent.filePath;

        /* eslint-disable jsx-a11y/alt-text */
        return (
            <div className={containerClass}>
                <div className={CardViewStyles.CustomThumbnailTopContainer}>
                    <div className={CardViewStyles.DatabaseCustomThumbnailImg}>
                        <img src={imgUrl}
                             width={'60px'} height={'60px'}
                             data-tb-test-id= 'table-icon' />
                    </div>
                    <div>{isDbServer ? Messages.database() + ': '+ tableContent.databaseName : Messages.fileName() + ': ' + tableContent.fileName}</div>
                    <div className={CardViewStyles.DatabaseCustomSecondTitle}>{thumbnailSecondTitle}</div>
                </div>
                {this.props.contentUrl &&
                    telemetryConsumerWrapper(ContentClickedTelemetryContext.Consumer, (sendOpenContentTelemetry: ContentClickedEventHandler) =>
                        /* eslint-disable jsx-a11y/anchor-has-content */
                        <a
                            onMouseUp={mouseUpFactory<HTMLAnchorElement>(sendOpenContentTelemetry)}
                            href={this.props.contentUrl}
                            className={CardViewStyles.AnchorUnderlay}
                            draggable={this.props.allowDragAndDrop ? false : undefined}
                            aria-label={this.props['aria-label']}
                        ></a>
                    )
                }
            </div>
        );
    }

}
